import "../css/Pagination.css";

const Pagination = ({ currentPage = 1, totalPages = 1, onPageChange }) => {
  const generatePages = () => {
    const delta = 2;

    const range = (start, end) =>
      Array.from({ length: end - start + 1 }, (_, i) => start + i);

    const withDots = (pages) => {
      const result = [];
      let lastPage = 0;

      for (let page of pages) {
        if (page - lastPage > 1) {
          result.push("...");
        }
        result.push(page);
        lastPage = page;
      }

      return result;
    };

    if (totalPages <= 7) {
      return range(1, totalPages);
    }

    const left = Math.max(2, currentPage - delta);
    const right = Math.min(totalPages - 1, currentPage + delta);
    return withDots([1, ...range(left, right), totalPages]);
  };

  const pagesToShow = generatePages();

  const handleChange = (page) => {
    if (typeof page === "number" && page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page);
    }
  };

  return (
    <div className="pagination-wrapper">
      <button
        onClick={() => handleChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="pagination-button"
        aria-label="Previous page"
      >
        «
      </button>

      {pagesToShow.map((page, idx) =>
        page === "..." ? (
          <span key={`dots-${idx}`} className="pagination-dots">
            ...
          </span>
        ) : (
          <button
            key={page}
            className={`pagination-button ${currentPage === page ? "active" : ""}`}
            onClick={() => handleChange(page)}
          >
            {page}
          </button>
        )
      )}

      <button
        onClick={() => handleChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="pagination-button"
        aria-label="Next page"
      >
        »
      </button>
    </div>
  );
};

export default Pagination;
